import { useMemo } from "react";
import useMitreCategories from "security-app/components/SecurityEvents/Alerts/MitreCategories/useMitreCategories";
export const formatMitreCategory = (id, nameById) => {
  const name = nameById.get(id.toLocaleUpperCase());
  return name ? `${id}: ${name}` : id;
};
const useMitreNameIndex = () => {
  const { data, isInitialLoading } = useMitreCategories();
  const nameById = useMemo(() => {
    var _a;
    const index = /* @__PURE__ */ new Map();
    const add = ({ id, name }) => {
      const key = id.toLocaleUpperCase();
      if (!index.has(key)) index.set(key, name);
    };
    ((_a = data == null ? void 0 : data.tactics) != null ? _a : []).forEach((tactic) => {
      var _a2;
      add(tactic);
      ((_a2 = tactic.techniques) != null ? _a2 : []).forEach((technique) => {
        var _a3;
        add(technique);
        ((_a3 = technique.subtechniques) != null ? _a3 : []).forEach(add);
      });
    });
    return index;
  }, [data == null ? void 0 : data.tactics]);
  return { nameById, isLoadingNames: isInitialLoading };
};
export default useMitreNameIndex;
